import { render, staticRenderFns } from "./BaseAccordionItem.vue?vue&type=template&id=02bacf87&scoped=true&"
var script = {}
import style0 from "./BaseAccordionItem.vue?vue&type=style&index=0&id=02bacf87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bacf87",
  null
  
)

export default component.exports